<template>
    <div id="menu_btn" :class="{'active': isShowText}">
        <div id="side_button" @click="showText"><span></span><span></span><span></span></div>
        <p class="txt">MENU</p>
    </div>
    <div id="layer" :class="{'show': isShowText}"></div>
    <transition>
    <nav id="globalnav" :class="{'show': isShowText}">
        <div class="in_nav">
            <div class="sp_header">探す</div>
            <div class="main_menu">
                <a href="/departure/" class="nav01">
                    <dl>
                        <dt><img loading="lazy" src="/user/assets/images/common/marker_ico.png" alt="出発地から探す"></dt>
                        <dd>出発地から探す</dd>
                    </dl>
                </a>
                <a href="/destination/" class="nav02">
                    <dl>
                        <dt><img loading="lazy" src="/user/assets/images/common/yama_ico.png" alt="スキー場から探す"></dt>
                        <dd>スキー場から探す</dd>
                    </dl>
                </a>
                <a href="/transportation/" class="nav03">
                    <dl>
                        <dt><img loading="lazy" src="/user/assets/images/common/car_ico.png" alt="交通手段で探す"></dt>
                        <dd>交通手段で探す</dd>
                    </dl>
                </a>
            </div>
            <div class="sp_header">その他メニュー</div>
            <div class="other_menu">
                <a href="/" class="nav05">
                    <dl>
                        <dt><img loading="lazy" src="/user/assets/images/common/home_ico.png" alt="HOMEに戻る"></dt>
                        <dd>HOMEに戻る</dd>
                    </dl>
                </a>
            </div>
        </div>
    </nav>
    </transition>
</template>

<script>
    import { ref } from "vue"
    export default ({
        props: {
        },
        setup (props, context) {

            const isShowText = ref(false)

            // メソッド実装 押されたとき
            const showText = () => {
                if (isShowText.value) {
                    isShowText.value = false
                } else {
                    isShowText.value = true
                }
            }

            return {
                isShowText,
                showText,
            }
        },
    })
</script>

<style>
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
</style>